import React, { useState, useRef, useEffect, useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { loginByBio } from '@store/actions/userAction';

import {
    isMobile,
    isBioMetricsAvailable,
    callBioMetrics,
    encryptNative,
} from '@common/utils/device';

const LoginBioMain = () => {
    const {
        userInfo: { username, userId },
        loginInfo : { loginMethodComment },
        bioMetricsInfo
    } = useSelector(state => state.userReducer);
    const dispatch = useDispatch();
    
    useEffect(() => {
        window.addEventListener(
            'isBioMetricsAvailableCallBack',
            isBioMetricsAvailableCallBack
        );
        isBioMetricsAvailable();

        return () => {
            window.removeEventListener(
                'isBioMetricsAvailableCallBack',
                isBioMetricsAvailableCallBack,
            );
            window.removeEventListener(
                'callBioMetricsCallBack',
                callBioMetricsCallBack,
            );
        };
    }, []);

    const isBioMetricsAvailableCallBack = useCallback(props => {
        const {
            data: { isBioMetricsAvailable, isBioMetricsActive, bioMetricsKind },
        } = props;

        if (isBioMetricsAvailable && isBioMetricsActive) {
            window.addEventListener(
                'callBioMetricsCallBack',
                callBioMetricsCallBack,
            );
            callBioMetrics();
        }
    }, []);

    const callBioMetricsCallBack = ({ data: { isSuccess } }) => {
        if (isSuccess) {
            dispatch(loginByBio({
                // pw : easyPw,
                faceBioCertiYn : bioMetricsInfo.bioMetricsKind !== 'TouchId' ? 'Y' : 'N',
                fngprtBioCertiYn : bioMetricsInfo.bioMetricsKind === 'TouchId' ? 'Y' : 'N',
            }));
        }
    };
    
    return (
        <>
            <div className='tit-area'>
                <p className='tit title-h5'>
                    <span>{username}({userId})</span>님 반갑습니다.<br />
                    등록한 생체정보로 로그인해주세요.
                </p>
            </div>

            <div className='login-form'>
                <div className='flex jc text-center'>
                    <div className='biobox'>
                        { bioMetricsInfo.bioMetricsKind === 'TouchId' ? (
                            <span className='ico ico-touch-id center'></span>
                        ) : (
                            <span className='ico ico-face center'></span>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}

export default LoginBioMain;